import { Component, Host, Prop, h } from '@stencil/core';

/**
 * @slot - Designed to add custom content in the app bar.
 */
@Component({
  tag: 'sy-app-bar',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class AppBar {
  /**
   * Set app bar background-color attribute (accept system's colors).
   */
  @Prop({ reflect: true }) color: 'primary' | 'secondary' | 'error' | 'warning' | 'success' | 'info';

  componentDidLoad() {
    console.warn('<sy-app-bar> component has been deprecated and will be removed starting from version 2.0.0.');
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
